import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ToastService } from '@horizon/core-notifications';
import { HorizonPaymentGatewayService } from '@shared/services/horizon-payment-gateway.service';
import { EMPTY, Observable, Subject, takeUntil } from 'rxjs';
import { PaymentSocketData } from './models/horizon-payment-getaway.model';
import { globalSettings } from 'src/global-settings';

@Component({
  selector: 'horizon-payment-getaway',
  templateUrl: `./horizon-payment-getaway.component.html`,
  styleUrls: ['./horizon-payment-getaway.component.scss'],
})
export class HorizonPaymentGetawayComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  public globalSettings: any = globalSettings;

  @Input() paymentData: {
    sessionId: string;
    accessToken: string;
    refreshToken: string;
  };
  @Input() showPCIPal: boolean = false;
  @Output() paymentFinished: EventEmitter<PaymentSocketData> =
    new EventEmitter<PaymentSocketData>();
  @ViewChild('embedForm', { static: false })
  embedForm!: ElementRef<HTMLFormElement>;

  iframeActionUrl = '';

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private paymentGatewayService: HorizonPaymentGatewayService,
    private readonly toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.generateIframeActionURL();
  }

  ngAfterViewInit(): void {
    this.initializeIframe().then(() => {
      this.paymentGatewayService.initializePaymentSession(
        this.paymentData.accessToken,
        this.paymentData.sessionId
      );

      this.paymentGatewayService
        .getPaymentStatus()
        .pipe(takeUntil(this.destroy$))
        .subscribe((paymentData) => {
          this.paymentFinished.emit(paymentData);
        });
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.paymentGatewayService.closePaymentSession();
  }

  public cancelPayment(): void {
    this.paymentFinished.emit();
  }

  private generateIframeActionURL(): void {
    try {
      this.iframeActionUrl = this.paymentGatewayService.pcipalIframeUrl(
        this.paymentData.sessionId
      );
    } catch (error) {
      this.handleError(error);
      setTimeout(() => {
        this.paymentFinished.emit({
          sessionId: this.paymentData.sessionId,
          status: 'error',
          errors: [error.message],
        } as unknown as PaymentSocketData);
      }, 3000);
    }
  }

  private async initializeIframe(): Promise<void> {
    try {
      this.embedForm.nativeElement.submit();
    } catch (error) {
      this.handleError(error);
      setTimeout(() => {
        this.paymentFinished.emit({
          sessionId: this.paymentData.sessionId,
          status: 'error',
          errors: [error.message],
        } as unknown as PaymentSocketData);
      }, 3000);
    }
  }

  private handleError(error: any): Observable<never> {
    console.error(error.message, error);
    this.toastService.showToastNotification({
      text: error.message,
      type: 'error',
    });
    return EMPTY;
  }
}
